import { render, staticRenderFns } from "./Motor.vue?vue&type=template&id=66d08c96&"
import script from "./Motor.vue?vue&type=script&lang=ts&"
export * from "./Motor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d08c96')) {
      api.createRecord('66d08c96', component.options)
    } else {
      api.reload('66d08c96', component.options)
    }
    module.hot.accept("./Motor.vue?vue&type=template&id=66d08c96&", function () {
      api.rerender('66d08c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/v2/Motor.vue"
export default component.exports